import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import { ConfigProvider, Pagination, Space, Switch, Table, TableColumnsType } from 'antd'
import viVN from 'antd/locale/vi_VN'
import { Link } from 'react-router-dom'
import { DataTypeGeneralConfiguration } from '..'
import { addWorkSession } from '../../../../api/workSessionSetting/workSessionSettingApi'
import BreadcrumbBlock from '../../../../components/BreadcrumbBlock/BreadcrumbBlock'
import useDebounce from '../../../../hook/useDebounce'
import useInfoUser from '../../../../hook/useInfoUser'
import useLoading from '../../../../hook/useLoading'
import useToast from '../../../../hook/useToast'
import { formatNumber } from '../../../../services/mixin'
import Layout from '../../../../Layout'
import ModalNotificationEmailTemplate from '../Modal/ModalNotificationEmailTemplate'
import { useState } from 'react'

const data = [
    {
        key: '1',
        name: 'Mẫu email thông báo 1',
        eventTrigger: 'Sự kiện 1',
    },
    {
        key: '2',
        name: 'Mẫu email thông báo 2',
        eventTrigger: 'Sự kiện 2',
    },
]

const NotificationEmailTemplate = () => {
    const { getInfoUser, setTimeSessionTimeout } = useInfoUser()
    const { sessionTimeout } = getInfoUser()
    const pushToast = useToast();
    const pushLoading = useLoading()

    const [isModalNotificationEmailTemplate, setIsModalNotificationEmailTemplate] = useState(false)
    const [type, setType] = useState<number>(1)

    const onChangeSessionTimeout = useDebounce(async (value: number) => {
        pushLoading(true)
        const result = await addWorkSession(value)
        if (result?.status) {
            setTimeSessionTimeout(value)
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)


    const columns: TableColumnsType<any> = [
        {
            title: 'Hành động',
            dataIndex: '',
            key: 'action',
            render: (_: any, record: any) => (
                <Space size="middle">
                    <EyeOutlined
                        className='custom-page-css text-sm border-D9D9D9 p-5-px bg-white rounded cursor-pointer'
                        onClick={() => handleOpenModal(Number(record.key))}
                    />
                </Space>
            ),
        },
        {
            title: 'Tên',
            dataIndex: 'name',
            key: 'name',

        },

        {
            title: 'Sự kiện được kích hoạt',
            dataIndex: 'eventTrigger',
            key: 'eventTrigger',
            align: 'center',
        },
    ]

    const handleOpenModal = (key: number) => {
        setIsModalNotificationEmailTemplate(true)
        setType(key)
    }

    return (
        <div className="notification-templates-management">
            <ModalNotificationEmailTemplate
                open={isModalNotificationEmailTemplate}
                type={type}
                onCancel={() => setIsModalNotificationEmailTemplate(false)}
            />
            <Layout>
                <BreadcrumbBlock
                    items={[
                        { title: <Link to="/">THACO AUTO CRM</Link>, },
                        { title: 'Quản trị phần mềm', },
                        { title: <Link to="/system-configuration/general-configuration">Cấu hình hệ thống</Link>, },

                        { title: 'Mẫu email thông báo', },
                    ]}
                    title=''
                />
                <div className="d-flex align-center justify-between pb-3">
                    <span className="custom-page-css font-medium text-xl lh-24">Mẫu email thông báo</span>
                    {/* <button
                        className="rounded-6-px h-8 w-83-px text-white bg-1890FF border-none text-sm"
                        onClick={() => setIsModalNotificationEmailTemplate(true)}
                    >
                        Tạo mới
                    </button> */}
                </div>
                <div className="custom-page-css flex flex-col flex-1 justify-between">
                    <Table
                        columns={columns}
                        dataSource={data}
                        showSorterTooltip={false}
                        className="rs-table notification-fees-table"
                        pagination={false}
                    />

                    <ConfigProvider locale={viVN}>
                        <div className="pagination-block">
                            <Pagination
                                showSizeChanger
                                // current={paginationTmp}
                                // pageSize={pagination.pageSize}
                                // total={pagination.total}
                                itemRender={(page, type, originalElement) => {
                                    // Chỉ custom khi là nút số trang
                                    if (type === 'page') {
                                        return <span>{formatNumber(page)}</span>;
                                    }
                                    // prev / next / jump-prev / jump-next giữ nguyên
                                    return originalElement;
                                }}
                                // showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, paginationTmp).totalPage} trang`}
                                className='rs-pagination'
                            // onChange={onPaginationChange}

                            />
                        </div>
                    </ConfigProvider>
                </div>
            </Layout>
        </div>
    )
}

export default NotificationEmailTemplate
